import cx from 'classnames';
import { FC, memo } from 'react';
import CookieConsent from 'react-cookie-consent';
import { IntlShape, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import ResizeFragment from './ResizeFragment';
import RotateDevice from './RotateDevice';
import { isInIframe } from '../../utils';
import { NODE_ENV, NODE_ENV_TYPES, THEME_TYPE } from '../../commons/constants';
import Routes from '../../routers/routes';
import { storeName } from '../../redux/models/layout.model';

type LayoutContentPropsTypes = { themeKey: string };

const LayoutContent: FC<LayoutContentPropsTypes> = ({ themeKey }) => {
  const intl: IntlShape = useIntl();

  const inIframe = isInIframe();

  const isMobileDevice = useSelector((state) => state[storeName].isMobileDevice);
  const isTabletDevice = useSelector((state) => state[storeName].isTabletDevice);

  return (
    <>
      <ResizeFragment />
      <RotateDevice />
      <div
        className={cx(
          'bds-hub__content-wrapper',
          { 'bds-hub__content-wrapper--mobile': isMobileDevice },
          { 'bds-hub__content-wrapper--tablet': isTabletDevice }
        )}
        data-theme={themeKey && THEME_TYPE[themeKey] ? THEME_TYPE[themeKey].dataTheme : undefined}
      >
        <Routes />
        {NODE_ENV_TYPES[NODE_ENV] && (
          <div className="bds-hub__prefix">
            <span>{NODE_ENV_TYPES[NODE_ENV].label}</span>
          </div>
        )}
      </div>

      {!inIframe && (
        <CookieConsent
          acceptOnScroll
          disableStyles
          buttonText={intl.formatMessage({ id: 'cookie.consent.agree' })}
          buttonClasses="cookie-consent__btn-accept"
          containerClasses="cookie-consent__container"
          contentClasses="cookie-consent__content"
        >
          {intl.formatMessage({ id: 'cookie.consent' })}
        </CookieConsent>
      )}
    </>
  );
};

const LayoutContentMemo = memo(LayoutContent);
export { LayoutContentMemo as LayoutContent };
